import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IPlan } from '../interfaces';
import { PlanMapper } from '../mappers';

export type IGetPlansRepoResponse = IRepoResponse<200, { data: IPlan[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetPlansRepo = IRepo<[any], IGetPlansRepoResponse>;

export const GetPlansRepoType = Symbol.for('GetPlansRepo');

@bind(GetPlansRepoType)
export class GetPlansRepo implements IGetPlansRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/client/v2/tariff/list', query) });

      if (result.status === 200) {
        const data: IPlan[] = result.data.data.map((user) => PlanMapper.toDomain(user));
        const total = result.data.total;

        return {
          status: 200 as 200,
          response: {
            data,
            total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
